export default __webpack_public_path__ + "static/media/1113.8afe3db3.JPG";